import { render, staticRenderFns } from "./BtnConnectProduct.vue?vue&type=template&id=1cc53706&"
import script from "./BtnConnectProduct.vue?vue&type=script&lang=js&"
export * from "./BtnConnectProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports